<template>
  <div class="title-with-icon">
    <p class="title-with-icon__title">
      {{ title }}
    </p>
    <div class="title-with-icon__content">
      <img
        v-if="imgIcon"
        :src="imgIcon"
        class="title-with-icon__content-img"
      >
      <i
        v-if="icon"
        class="title-with-icon__content-icon"
        :class="icon"
      />
      <p class="title-with-icon__title subtitle">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "TitleWithIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
    imgIcon: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/title-with-icon";
</style>